import { render, staticRenderFns } from "./AddSaleReturn.vue?vue&type=template&id=b4676c34&"
import script from "./AddSaleReturn.vue?vue&type=script&lang=js&"
export * from "./AddSaleReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports